// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__mQLmz","hero_content":"Home_hero_content__gHP3W","bold":"Home_bold__8t3sj","arrowDiv":"Home_arrowDiv__ZrxId"};